import styled from 'styled-components';

export const UiRadioGroup = styled.div`
	display: flex;
	flex-wrap: wrap;
`;
export const Uilabel = styled.h3`
	margin-right: 1rem;
`;

export const UiRadioList = styled.div`
	display: flex;
	flex-wrap: wrap;
	flex: 1;

	& > div {
		margin: 1rem;
		width: inherit;
	}
`;
